module.exports = __webpack_public_path__ + "static/media/WINTER_WHEAT_1x.fcb7a51d.png";